import CommonTable from "components/CommonTable";
import { TableRowData } from "components/CommonTable/types";
import { transformObjectToTableRow } from "components/CommonTable/utils";
import { ProductTechSpecs } from "features/ProductReel/types";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { noSelect, shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface TechnicalInfoProps {
  data: ProductTechSpecs;
}

const TechnicalInfo: React.FC<TechnicalInfoProps> = ({ data }) => {
  const commonSpecs = transformObjectToTableRow(data.data.common_specs?.data);
  const innerSpecs = transformObjectToTableRow(data.data.internal_specs?.data);
  const outerSpecs = transformObjectToTableRow(data.data.external_specs?.data);

  return (
    <TechnicalInfoContainer>
      <TablesContainer>
        {commonSpecs.length > 0 && (
          <MainSpecsContainer>
            <CommonTable title="Общи" data={commonSpecs} />
          </MainSpecsContainer>
        )}
        {innerSpecs.length > 0 && (
          <InnerBody>
            <CommonTable title="Вътрешно тяло" data={innerSpecs} />
          </InnerBody>
        )}
        {outerSpecs.length > 0 && (
          <OuterBody>
            <CommonTable title="Външно тяло" data={outerSpecs} />
          </OuterBody>
        )}
      </TablesContainer>
    </TechnicalInfoContainer>
  );
};

const TechnicalInfoContainer = styled.div`
  ${noSelect}
  width: 100%;

  @media only screen and (${device.tablet}) {
    padding: 20px;
    box-sizing: border-box;
    background-color: ${colors.gray};
  }
`;
TechnicalInfoContainer.displayName = "TechnicalInfoContainer";

const TablesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 1fr);
  grid-row-gap: 10px;

  @media only screen and (${device.tablet}) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 10px;
  }
`;
TablesContainer.displayName = "TablesContainer";

const MainSpecsContainer = styled.div`
  grid-row: 1/7;
`;
MainSpecsContainer.displayName = "MainSpecsContainer";

const InnerBody = styled.div``;
InnerBody.displayName = "InnerBody";

const OuterBody = styled.div``;
OuterBody.displayName = "OuterBody";

export default TechnicalInfo;
